<template>
  <div>
    <div ref="container">
      <a-affix :offsetTop="0">
        <a-page-header
          style="border-bottom: 1px solid rgb(235, 237, 240); background: #fff"
          class="mb-5 px-0"
          title='Add Voucher'
          @back="() => $router.push('/discounts')"
        >
        </a-page-header>
      </a-affix>
    </div>
    <VoucherForm />
  </div>
</template>

<script>
import VoucherForm from '../../../components/Voucher/Form'

export default {
  components: {
    VoucherForm,
  },
}
</script>
